import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

const TeamFilterContext = createContext(null);

const ANGELS_KEYWORDS = [
  "angels", "angel ", "halo", "halos", "anaheim angels", "trout", "ohtani",
  "rendon", "arte", "tarps", "rally monkey", "big a", "moreno", "minasian",
  "neto", "ward", "schanuel", "drury", "adell", "thaiss", "soriano",
  "fletcher", "stefanic", "moncada", "soler", "pujols", "ron washington",
  "angel stadium", "mlb", "baseball", "infield", "outfield", "bullpen",
];

const DUCKS_KEYWORDS = [
  "ducks", "duck ", "anaheim ducks", "hockey", "nhl", "honda center",
  "carlsson", "gauthier", "zegras", "terry", "mctavish", "killorn",
  "mintyukov", "lacombe", "dostal", "gibson", "vatrano", "strome",
  "fowler", "lyubushkin", "wild wing", "puck", "ice", "skate",
];

const NFL_KEYWORDS = [
  "nfl", "football", "gridiron", "quarterback", "qb", "touchdown", "td ",
  "super bowl", "superbowl", "playoff", "unfiltered", "hiti unfiltered",
  "rams", "chargers", "49ers", "niners", "chiefs", "cowboys", "eagles",
  "patriots", "bills", "packers", "bengals", "ravens", "steelers", "lions",
  "vikings", "commanders", "broncos", "seahawks", "browns", "titans", "jets",
  "coach", "draft", "combine", "sofi", "levi's stadium",
];

function detectTeam(text) {
  if (!text) return null;
  const lower = text.toLowerCase();
  const isDucks = DUCKS_KEYWORDS.some((kw) => lower.includes(kw));
  const isNfl = NFL_KEYWORDS.some((kw) => lower.includes(kw));
  const isAngels = ANGELS_KEYWORDS.some((kw) => lower.includes(kw));
  const tags = [];
  if (isAngels) tags.push("angels");
  if (isDucks) tags.push("ducks");
  if (isNfl) tags.push("nfl");
  if (tags.length === 0) return null;
  if (tags.length === 1) return tags[0];
  return tags; // multiple
}

export const TeamFilterProvider = ({ children }) => {
  const [team, setTeam] = useState("all"); // "all" | "angels" | "ducks" | "nfl"

  const toggle = useCallback((target) => {
    setTeam((cur) => (cur === target ? "all" : target));
  }, []);

  const matches = useCallback((text) => {
    if (team === "all") return true;
    const detected = detectTeam(text);
    if (!detected) return false;
    if (Array.isArray(detected)) return detected.includes(team);
    return detected === team;
  }, [team]);

  const value = useMemo(() => ({ team, setTeam, toggle, matches }), [team, toggle, matches]);

  return <TeamFilterContext.Provider value={value}>{children}</TeamFilterContext.Provider>;
};

export const useTeamFilter = () => useContext(TeamFilterContext);
